import { START_FORM_VALIDATOR, START_RESET_FORM_VALIDATOR } from '../types';
    
export const formValidator = payload => ({
    type: START_FORM_VALIDATOR,
    payload
})

export const resetFormValidator = () => ({
    type: START_RESET_FORM_VALIDATOR
})